<template>
  <div class="sticky-add-to-bag">
    <Button width="full" @click="handleClick">{{ buttonText }}</Button>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/ButtonV3.vue";

export default {
  name: "StickyAddToBag",
  components: {
    Button,
  },
  computed: {
    buttonText() {
      return "Add to bag";
    },
  },
  methods: {
    ...mapActions("cart", ["addCartItem", "setCartOpen"]),
    handleClick() {
      this.scrollToCta();
    },
    scrollToCta() {
      const cta = document.querySelector('[data-testid="add-to-bag"]');
      cta.scrollIntoView({ behavior: "smooth", block: "center" });
    },
  },
};
</script>

<style lang="scss" scoped>
.sticky-add-to-bag {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 20px;
  z-index: 3;
}

.onsale {
  text-decoration: line-through;
}
</style>
